<template>
  <default-layout>
    <event-navbar :title="userDisplay()" />
    <div class="container">
      <hrmine-welcome :first-name="user.first_name" :hints="welcomeHints" />
      <ul class="list-group">
        <li v-for="(v, k) in favoritesByTitle" :key="k" @click.prevent="routeToFavorites(v)"
          class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
          {{ k }}
          <span class="badge bg-primary badge-pill">{{ favorites[favKey(v)]?.length || 0 }}</span>
        </li>

        <li class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
         @click.prevent="meetings()">
          Meetings
          <i class="fas fa-calendar-check"></i>
        </li>

        <li class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
         @click.prevent="tickets()">
          Tickets
          <i class="fas fa-ticket-alt"></i>
        </li>

        <li class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
         @click.prevent="userTimeline()">
          Meine Agenda (Timeline)
          <i class="fas fa-calendar-week"></i>
        </li>

        <li class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
         @click.prevent="contacts()">
          Kontakte
          <span>
          <span class="badge bg-danger badge-pill me-1"><i class="far fa-envelope"></i> {{ numUnreadMessages }}</span>
          <span class="badge bg-primary badge-pill">{{ directChannels.length || 0 }}</span>
          </span>
        </li>

        <li class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
         @click.prevent="community()">
          Community
          <i class="fas fa-users"></i>
        </li>

        <li class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
         @click.prevent="townSquare()">
          Town Square
          <i class="fas fa-comments"></i>
        </li>

        <li class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
         @click.prevent="exhibitorScan()">
          Standbesuch erfassen
          <i class="fas fa-qrcode"></i>
        </li>

        <li class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
         @click.prevent="showVisits()">
          Meine Standbesuche
          <i class="far fa-eye"></i>
        </li>

        <li class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
         @click.prevent="$router.push('/about')">
          Über diese App
          <i class="fas fa-info-circle"></i>
        </li>

        <li class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
         @click.prevent="logout()">
          Ausloggen
          <i class="fas fa-sign-out-alt"></i>
        </li>

      </ul>
      <p class="text-small text-muted text-right">App Version: {{ appVersion }}</p>
    </div>
    <!--div class="container">
      <app-rating product="App" />
    </div-->
  </default-layout>
</template>

<script>
import EventNavbar from '@/components/EventNavbar.vue'
import DefaultLayout from '@/components/DefaultLayout.vue'
import FavoriteTitlesMixin from '@/components/lib/favorite-titles-mixin.js'
//import AppRating from '@/components/rating/app-rating.vue'
import HrmineWelcome from '@/components/HrmineWelcome.vue'

export default {
  name: 'UserProfileView',
  //components: {EventNavbar, DefaultLayout, AppRating, HrmineWelcome},
  components: {EventNavbar, DefaultLayout, HrmineWelcome},
  mixins: [FavoriteTitlesMixin],
  data() {
    return {
      user: this.$storage.user,
      favorites: {},
      appVersion: process.env.APP_VERSION,
      initialUnreads: this.$storage.observed.numDirectUnreadMessages,
      observed: this.$storage.observed,
      welcomeHints: {},
    }
  },

  computed: {
    directChannels() { return this.observed.directChannels },
    numUnreadMessages() { return this.observed.numDirectUnreadMessages },
  },

  created() {
    this.$storage.fetchUser().then((response) => {
      this.user = response.data
      this.favorites = this.$storage.getFavorites()
    }).catch(error_response => {
      if (error_response.response.status == 403) {
        console.log('redirecting ...')
        localStorage.removeItem('speaker_tool_token')
        this.$router.push('/login')
      }
    })
  },

  mounted() {
    let me = this
    this.$storage.getDirectUnreads().then(() => {
      me.observed = this.$storage.observed
    })
    this.$api.get('/ai-chat/welcome-hints/')
      .then(({ data }) => { this.welcomeHints = data })
      .catch(() => {})
  },

  methods: {
    userDisplay() {
      return `${this.user.first_name}  ${this.user.last_name}`.trim() || this.user.username
    },
    favKey(key) {
      return key == 'talk' ? 'favorite_session' : `favorite_${key}`
    },
    routeToFavorites(key) {
      let route = `/user-profile/${key}-favorites`
      this.$router.push(route)
    },
    logout() {
      this.$storage.performLogout()
      this.$router.push('/')
    },
    contacts() {
      this.$router.push('/user-profile/contacts')
    },
    community() {
      this.$router.push('/community')
    },
    townSquare() {
      this.$router.push('/channel-town-square')
    },
    userTimeline() {
      this.$router.push('/user-profile/timeline')
    },
    meetings() {
      this.$router.push('/user-profile/meetings')
    },
    tickets() {
      this.$router.push('/user-profile/tickets')
    },
    exhibitorScan() {
      this.$router.push('/user-profile/exhibitor-scan')
    },
    showVisits() {
      this.$router.push('/exhibitors?visits=true')
    }
  }
}
</script>
